/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';

// eslint-disable-next-line no-unused-vars
export const useBenefitPrices = (params: { versionId: string; search: string }) => {
  const result = useQuery({
    queryKey: ['benefits/prices'],
    queryFn: () => BenefitsService.getBenefitPrices(params),
    enabled: true,
  });
  return result;
};
